/**
 * Gift Message Component
 * Handles the gift message checkbox and textarea functionality in the cart
 */
class GiftMessageComponent extends HTMLElement {
  constructor() {
    super();

    this.checkbox = this.querySelector('[name="attributes[is-gift]"]');

    if (this.checkbox) {
      this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
    }
  }

  handleCheckboxChange(event) {
    const isChecked = event.target.checked;

    // Optimistic UI - show/hide textarea immediately
    this.toggleTextarea(isChecked);

    const headers = new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });

    const body = {
      attributes: {
        'is-gift': isChecked ? 'yes' : '',
      },
    };

    if (!isChecked) {
      body.attributes['gift-message'] = '';
      this.dataset.giftMessage = '';
    }

    const request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body),
    };

    // Update cart in background - no need to wait for re-render
    fetch(`${window.FoxThemeSettings.routes.cart_update_url}`, request)
      .then((response) => response.json())
      .then((cart) => {
        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, cart);
      })
      .catch((e) => {
        console.error(e);
        // Revert on error
        this.checkbox.checked = !isChecked;
        this.toggleTextarea(!isChecked);
      });
  }

  toggleTextarea(show) {
    let textareaWrapper = this.querySelector('gift-message-textarea');
    const textareaId = this.dataset.textareaId || 'f-gift-message-textarea';

    if (show && !textareaWrapper) {
      const existingMessage = this.dataset.giftMessage || '';

      // Create and insert textarea
      textareaWrapper = document.createElement('gift-message-textarea');
      textareaWrapper.className = 'f-gift-message__textarea-wrapper';
      textareaWrapper.innerHTML = `
        <textarea
          class="form-control form-control--textarea w-full f-gift-message__textarea"
          name="attributes[gift-message]"
          id="${textareaId}"
          placeholder="${window.FoxThemeStrings?.giftMessagePlaceholder || 'Add your gift message here (optional)'}"
          rows="3"
        >${existingMessage}</textarea>
      `;
      this.appendChild(textareaWrapper);

      // Focus the textarea for better UX
      requestAnimationFrame(() => {
        const textarea = textareaWrapper.querySelector('textarea');
        if (textarea) textarea.focus();
      });
    } else if (!show && textareaWrapper) {
      // Remove textarea
      textareaWrapper.remove();
    }
  }
}

customElements.define('gift-message-component', GiftMessageComponent);

/**
 * Gift Message Textarea Component
 * Handles debounced saving of gift message text
 */
class GiftMessageTextarea extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'input',
      debounce((event) => {
        const headers = new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        });

        const request = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            attributes: { 'gift-message': event.target.value },
          }),
        };

        fetch(`${window.FoxThemeSettings.routes.cart_update_url}`, request);
      }, 300)
    );
  }
}

customElements.define('gift-message-textarea', GiftMessageTextarea);
